export default "__VITE_ASSET__Bj5qXvA1__"